import request from '@/utils/request';
const path = 'channelInterfaceAuth';

/** 编辑/新增账号授权配置接口 */
export function updateOrCreateConfigApi(data) {
  return request({
    url: `/${path}/updateOrCreateConfig`,
    method: 'post',
    data,
  });
}

/** 获取账号授权配置接口 */
export function getConfigApi(params) {
  return request({
    url: `/${path}/getConfig`,
    method: 'get',
    params,
  });
}

/** 删除账号授权配置接口 */
export function delConfigApi(id) {
  return request({
    url: `/${path}/delConfig/${id}`,
    method: 'delete',
  });
}

/** 获取账号授权链接接口 */
export function getGrantUrlApi(params) {
  return request({
    url: `/${path}/grantUrl`,
    method: 'get',
    params,
  });
}

/** 授权接口 - bilibili */
export function authApi(data) {
  return request({
    url: `/${path}/auth`,
    method: 'post',
    data,
  });
}

/** 批量修改应用和应用下所有广告主返点接口 */
export function updateSelfAndSubRebateApi(data) {
  return request({
    url: `/${path}/updateSelfAndSubReBate`,
    method: 'put',
    data,
  });
}

/** 添加广告主接口 */
export function addAdvertiserApi(data) {
  return request({
    url: `/${path}/addAdvertiser`,
    method: 'post',
    data,
  });
}
